import { createRouter } from '../Router.mjs';

const { RouterProvider: SsoRouterProvider, Router: SsoRouter, useRouterController: useSsoRouterController} = createRouter();

export { SsoRouter, SsoRouterProvider, useSsoRouterController };
//# sourceMappingURL=SSORouter.mjs.map
